// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progresso {
  width: 100%;
  height: 90px;
  margin-top: 30px;
}

#barra-xp {
    appearance: none;
    width: 100%;
    height: 90px;
    border-radius: 12px;
    overflow: hidden;
  }
  
  #barra-xp::-webkit-progress-bar {
    background-color: var(--cor-roxoClaro);
    border-radius: 12px;
  }
  
  #barra-xp::-webkit-progress-value {
    background-color: var(--cor-roxoEscuro);
    border-radius: 12px;
    -webkit-transition: width 0.3s ease;
    transition: width 0.3s ease;
  }

  #barra-xp::-moz-progress-bar {
    background-color: var(--cor-roxoEscuro);
    border-radius: 12px;
    -moz-transition: width 0.3s ease;
    transition: width 0.3s ease;
  }

  .texto-progresso {
    color: var(--cor-roxoApoio);
    font-weight: 500;
    font-size: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
  }`, "",{"version":3,"sources":["webpack://./src/Componets/InputProgresso.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,uCAAuC;IACvC,mBAAmB;IACnB,mCAA2B;IAA3B,2BAA2B;EAC7B;;EAEA;IACE,uCAAuC;IACvC,mBAAmB;IACnB,gCAA2B;IAA3B,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB","sourcesContent":[".progresso {\n  width: 100%;\n  height: 90px;\n  margin-top: 30px;\n}\n\n#barra-xp {\n    -moz-appearance: none;\n    appearance: none;\n    width: 100%;\n    height: 90px;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  \n  #barra-xp::-webkit-progress-bar {\n    background-color: var(--cor-roxoClaro);\n    border-radius: 12px;\n  }\n  \n  #barra-xp::-webkit-progress-value {\n    background-color: var(--cor-roxoEscuro);\n    border-radius: 12px;\n    transition: width 0.3s ease;\n  }\n\n  #barra-xp::-moz-progress-bar {\n    background-color: var(--cor-roxoEscuro);\n    border-radius: 12px;\n    transition: width 0.3s ease;\n  }\n\n  .texto-progresso {\n    color: var(--cor-roxoApoio);\n    font-weight: 500;\n    font-size: 1rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
